module.exports = __webpack_public_path__ + "img/emojione_fountain-pen.bd6a9382.svg";